module.exports = __webpack_public_path__ + "assets/fonts/ProximaNova-Regular.2865bf7a.eot";